import { FieldsResponse } from '../types/api';
import { API_CONSTANTS } from '../constants/api-constants';
import axios from 'axios';
import { AxiosError } from 'axios';
import { getValidMaiaAccessToken, tenantHeaderFor } from './auth/brokerSession';

// Custom error interface for API errors
interface ApiError extends Error {
  response?: {
    data?: {
      message?: string;
    };
    status?: number;
  };
  config?: {
    url?: string;
    method?: string;
  };
}

export const fieldsService = {
  // Fetch fields list
  async getFieldsList(tenantId: string): Promise<FieldsResponse> {
    try {
      const token = await getValidMaiaAccessToken();
      const response = await axios.get<FieldsResponse>(
        `${API_CONSTANTS.RULES_BASE_URL}${API_CONSTANTS.ENDPOINTS.FIELDS.LIST}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            ...tenantHeaderFor(tenantId),
          },
        },
      );
      return response.data;
    } catch (error: unknown) {
      const axiosError = error as AxiosError<{ message?: string }>;
      const apiErrorMessage = axiosError?.response?.data?.message;

      const errorMessage =
        apiErrorMessage || axiosError?.message || 'Failed to fetch fields list';

      const customError = new Error(errorMessage) as ApiError;
      customError.response = axiosError?.response;
      customError.config = axiosError?.config;

      throw customError;
    }
  },
};
